<script>
import {ref, watch} from "vue";
import useValidation from "@/use/Validation";
import useSharedSelectData from "@/use/SharedSelectData";

export default {
    props: {
        value: Array,
        type: String,
        readonly: Boolean,
        initQuestions: Array,
    },
    setup(props, { emit }) {
        const {mxRules} = useValidation();
        const {questionTypes} = useSharedSelectData();

        const questions = ref([]);

        const selectedQuestion = ref({selections: []});
        const questionDialog = ref(false);

        function selectQuestion(question) {
            selectedQuestion.value = question;
            questionDialog.value = true;
        }

        function addQuestion() {
            questions.value.push({selections: []});
        }

        function removeQuestion(index) {
            questions.value.splice(index, 1);
        }

        watch(() => props.initQuestions, (newVal) => {
            if (newVal && newVal.length > 0) {
                questions.value = JSON.parse(JSON.stringify(newVal));
            }
        }, {deep: true, immediate: true});

        watch(() => questions.value, () => {
            emit('input', questions.value);
        }, {deep: true});

        return {
            mxRules,
            questionTypes,
            questions,
            selectedQuestion,
            questionDialog,
            selectQuestion,
            addQuestion,
            removeQuestion,
        }
    }
}
</script>

<template>
    <div>
        <w-fieldset
            :title="$t('common.questions')"
            :show-add-action="!readonly"
            @add="addQuestion"
        >
            <v-row
                dense
                v-for="(question, index) in questions"
                :key="`question-${index}`"
            >
                <v-col cols="8">
                    <w-label :label="$t('common.label')" required/>
                    <w-text-area
                        v-model="question.question"
                        :readonly="readonly"
                        :rules="[mxRules.required]"
                    />
                </v-col>
                <v-col cols="3">
                    <w-label :label="$t('common.type')" required/>
                    <w-enum-select
                        v-model="question.type"
                        :items="questionTypes"
                        :readonly="readonly"
                        :rules="[mxRules.required]"
                    />
                </v-col>
                <v-col cols="1">
                    <w-btn-icon
                        v-if="!readonly"
                        classe="mt-6"
                        color="blue darken-2"
                        @press="selectQuestion(question)"
                        icon="mdi-cog"
                    />
                    <w-btn-icon
                        v-if="!readonly"
                        classe="mt-6"
                        color="red"
                        @press="removeQuestion(index)"
                        icon="mdi-trash-can"
                    />
                </v-col>
            </v-row>
        </w-fieldset>

        <v-dialog
            v-model="questionDialog"
            scrollable
            persistent
            max-width="800"
        >
            <v-card>
                <w-toolbar color="teal" :title="$t('common.question')"/>
                <v-card-text>
                    <v-container fluid>
                        <v-row>
                            <v-col cols="12">
                                <w-simple-text-area
                                    v-model="selectedQuestion.question"
                                    readonly
                                />
                            </v-col>
                            <!--<v-col cols="12" v-if="question.type === 'SELECT_TYPE'">
                                <w-fieldset :title="$t('training.select')">
                                    <v-row dense>
                                        <v-col cols="7">
                                            <str-question-select-type-autocomplete
                                                v-model="question.questionSelectTypeId"
                                                :readonly="readonly"
                                                :rules="[mxRules.required]"
                                            />
                                        </v-col>
                                    </v-row>
                                </w-fieldset>
                                <br/>
                            </v-col>-->
                            <v-col cols="12" v-if="selectedQuestion.type === 'SELECT'">
                                <w-fieldset
                                    :title="$t('training.select')"
                                    show-add-action
                                    :readonly="readonly"
                                    @add="selectedQuestion.selections.push({})"
                                >
                                    <v-row
                                        dense
                                        v-for="(item, index) in selectedQuestion.selections"
                                        :key="`selections-t-${index}`"
                                    >
                                        <v-col cols="11">
                                            <w-text-field
                                                v-model="item.name"
                                                :label="`${$t('common.name')} *`"
                                                :readonly="readonly"
                                                :rules="[mxRules.required]"
                                            />
                                        </v-col>
                                        <v-col cols="1">
                                            <w-btn-icon
                                                color="red"
                                                icon="mdi-trash-can"
                                                :disabled="readonly"
                                                @press="selectedQuestion.selections.splice(index, 1)"
                                            />
                                        </v-col>
                                    </v-row>
                                </w-fieldset>
                            </v-col>
                            <v-col cols="12">
                                <w-label :label="$t('common.steps')" />
                                <str-evaluation-phase-autocomplete
                                    multiple
                                    :type="type"
                                />
                            </v-col>
                        </v-row>
                    </v-container>
                </v-card-text>
                <v-divider/>
                <v-card-actions>
                    <v-spacer/>
                    <w-btn-close @press="questionDialog = false"/>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <input type="hidden"/>
    </div>
</template>

<style scoped>

</style>